import { GrowthBookProvider } from '@growthbook/growthbook-react';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { SiteUnavailablePopup } from '@openx/components-core/lib/SiteUnavailablePopup/SiteUnavailablePopup';
import { SnackbarProvider, snakbarStyles } from '@openx/components-core/lib/Snackbar/SnackbarProvider';
import { theme } from '@openx/components-core/lib/theme/theme';
import { globalStyles } from '@openx/constants/styles';
import { useGrowthbook } from '@openx/utils/hooks/useGrowthbook';
import { createDefaultGrowthBook } from '@openx/utils/lib/createDefaultGrowthBook';
import type { SnackbarOrigin } from 'notistack';
import { useEffect, useRef } from 'react';
import { CTA_VERSION, GROWTHBOOK_API_HOST, GROWTHBOOK_API_KEY, GROWTHBOOK_NAME_ATTR } from './config';
import { Dashboard } from './modules/dashboard/Dashboard';

const snackBarProps: SnackbarOrigin = { horizontal: 'left', vertical: 'bottom' };

export const App = () => {
  // Default GrowthBook instance to prevent hook errors during loading
  const defaultGrowthBook = useRef(createDefaultGrowthBook());

  const { initialize: initializeGB, growthbook } = useGrowthbook({
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: GROWTHBOOK_API_KEY,
    appName: GROWTHBOOK_NAME_ATTR,
  });

  useEffect(() => {
    // biome-ignore lint/suspicious/noConsole: this util logs the differences between expected and given data
    console.info(`%cCTA version: ${CTA_VERSION}`, 'font-weight:bold;');
  }, []);

  useEffect(() => {
    initializeGB();
  }, [initializeGB]);

  return (
    <GrowthBookProvider growthbook={growthbook || defaultGrowthBook.current}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <SnackbarProvider anchorOrigin={snackBarProps}>
            <GlobalStyles styles={[globalStyles, snakbarStyles(theme)]} />
            <CssBaseline />
            <SiteUnavailablePopup />
            <Dashboard />
          </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </GrowthBookProvider>
  );
};
